
import React from 'react'
import { Modal as BSModal, ModalProps } from 'react-bootstrap'

import Times from '@/Components/SvgImages/Times';

import './Modal.scss'

interface Props extends ModalProps {
  show: boolean
  title?: string
  footer?: React.ReactNode
  optionsButtons?: any[]
  showCloseButton?: boolean
  onClose?: () => void
  zIndex?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10'
  scrollable?: boolean
  children: React.ReactNode
}

const Modal = (props: Props) => {

  const {
    show,
    title,
    footer,
    onClose,
    showCloseButton,
    children,
    className,
    backdropClassName,
    zIndex = '1',
    scrollable = false,
    ...rest
  } = props

  const optionsButtons = props.optionsButtons || []

  return (
    <BSModal
      show={show}
      onHide={onClose}
      className={`app-modal ${className} z-index-dialog-${zIndex}`}
      backdropClassName={`app-modal-backdrop z-index-backdrop-${zIndex} ${backdropClassName || ''}`}
      {...rest}
    >
      <BSModal.Header>
        {title && (
          <BSModal.Title>{props.title}</BSModal.Title>
        )}
        {(optionsButtons.length > 0 || showCloseButton) && (
          <div className="modal-options-buttons">
            {optionsButtons.map((button: any, i: number) => (
              <button
                key={i}
                className="modal-options-button"
                onClick={button.onClick}
                disabled={button.disabled}
              >
                {button.icon}
              </button>
            ))}
            {showCloseButton && (
              <button className="modal-options-button"
                onClick={onClose}
              >
                <Times
                  height={24}
                  width={24}
                />
              </button>
            )}
          </div>
        )}
      </BSModal.Header>
      <BSModal.Body className={`custom-scrollbar${scrollable ? ' scrollable' : ''}`}>
        {children}
      </BSModal.Body>
      {footer && (
        <BSModal.Footer>
          {footer}
        </BSModal.Footer>
      )}

    </BSModal>
  )
}

export default Modal
